/* eslint-disable react/no-unescaped-entities */
import PolicyPage from "components/policies/PolicyPage";
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import parse from "date-fns/parse";
import { useIntl } from "react-intl";

function TermsOfService() {
  const intl = useIntl();
  if (!intl.locale.startsWith("pt")) {
    return (
      <>
        <FundamenteiMetadata title="Terms of Service | Fundamentei" />
        <PolicyPage title="Terms of Service" lastUpdatedAt={parse("2023-10-25", "yyyy-MM-dd", new Date())}>
          <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
            <p>
              Fundamentei ("Fundamentei Serviços de Informação LTDA"), registered under CNPJ No. 35.804.692/0001-05,
              located at Av. das Américas, 4200 - bl 1 sl 305, Barra da Tijuca, Rio de Janeiro/RJ, ZIP Code 22640-907,
              establishes these Terms of Service for its users, according to the conditions and descriptions below:
            </p>
            <ul>
              <li>
                <p>
                  Fundamentei primarily offers its users information services regarding assets listed on B3 - Brazil
                  Bolsa Balcão S.A., The Nasdaq Stock Market, and The New York Stock Exchange, not limited solely to
                  this purpose. Thus, through this Agreement, users agree to the rules and conditions imposed for the
                  use of the services, as established in this Agreement and other documents available on the website
                  and/or its products.
                </p>
              </li>
              <li>
                <p>
                  The purpose of Fundamentei and its platform and/or products is solely informational, and does not
                  consist of financial, legal, tax, accounting, or any other type of recommendations. Therefore, none of
                  the information disclosed by any of its products or communication channels constitutes an offer or
                  solicitation to purchase, sell, rent, or invest in financial assets of any kind.
                </p>
              </li>
              <li>
                <p>
                  Since the information is collected and provided by third parties (such as, but not limited to: B3 -
                  Brazil Bolsa Balcão S.A., CVM - Comissão de Valores Mobiliários, U.S. Securities and Exchange
                  Commission, The Nasdaq Stock Market, The New York Stock Exchange, or other sources, services, and/or
                  partners), Fundamentei is not responsible for its content or for any inaccuracies, errors, delays,
                  imprecisions, or omissions in the information, and the user acknowledges that the use and validation
                  of the completeness of the services/products provided is their sole responsibility. However, we inform
                  you that we take precautions to ensure that the information and service are selected in the most
                  accurate manner possible. Furthermore, Fundamentei emphasizes its commitment to transparency and
                  legality, always observing the relevant legislation regarding intellectual property and copyright.
                </p>
              </li>
              <li>
                <p>
                  Fundamentei and/or its partners have no liability of any kind for losses or damages, whether direct or
                  indirect, arising from:
                </p>
                <ol className="list-decimal" type="i">
                  <li>
                    <p>
                      Errors, inaccuracies, partiality, absence, delays, interruptions, or omissions in the provision of
                      data and information related to the website or any of its products on any platform;
                    </p>
                  </li>
                  <li>
                    <p>
                      Any decision, omission, or action taken by the user or third parties based on this information, so
                      that they will not be liable for loss of profits or any other similar type of damage.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Fundamentei is assured the right, at any time, to modify the form and content, suspend, or cancel the
                  services, products, utilities, and applications provided on the site. Furthermore, Fundamentei
                  reserves the right to periodically update and modify the information, which should not be interpreted
                  as definitive by the user.
                </p>
              </li>
              <li>
                <p>
                  Fundamentei commits to the user to maintain and disclose the information and materials on its platform
                  as completely, accurately, and updated as possible.
                </p>
              </li>
              <li>
                <p>
                  The content, information, graphics, tables, and other data provided by Fundamentei and its partners
                  are for the user’s personal use only, and copying, distribution, reproduction, transmission,
                  exploitation, storage, or any other form of use for commercial purposes or any other purpose other
                  than personal use is not permitted, much less selling, reselling, or renting.
                  <strong>
                    The user assumes all civil and criminal responsibility for the misuse of the services and products
                    provided by Fundamentei and its partners.
                  </strong>
                </p>
              </li>
              <li>
                <p>
                  If it is found that the user is violating the Terms of Service in any way, Fundamentei is allowed to
                  cancel the subscription and/or block access to any of the products offered by Fundamentei temporarily,
                  permanently, and even preventively.
                </p>
              </li>
              <li>
                <p>
                  The use of any automation tools (software, scripts, third-party platforms, but not limited to these)
                  for extraction, analysis, or any type of manipulation of the data present on the platform and in any
                  of its products for any purposes is explicitly prohibited, and the user acknowledges that if they
                  engage in any conduct outlined here, they will be held civilly and criminally responsible for their
                  actions.
                </p>
              </li>
              <li>
                <p>
                  Registration is personal, unique, non-transferable, and for the exclusive use and responsibility of
                  the user, and sharing their account/password with third parties is prohibited, regardless of the
                  connection or degree of kinship and purpose (commercial, educational, etc.).
                </p>
              </li>
              <li>
                <p>
                  Certain functionalities of our site and platform will only be available upon registration and/or
                  payment, so the user will always be alerted when the service they are trying to access requires
                  registration and/or payment, allowing them to choose whether they wish to pay for the respective
                  service/product.
                </p>
              </li>
              <li>
                <p>
                  Fundamentei is not responsible for any damage to the user’s computer (software and hardware) resulting
                  from our services, and it is the user’s sole responsibility to take security measures for the
                  appropriate purposes.
                </p>
              </li>
              <li>
                <p>
                  The website and services of Fundamentei are subject to possible technical failures, interruptions,
                  and/or temporary unavailability, so Fundamentei disclaims any responsibility for damages arising from
                  the situations mentioned.
                </p>
              </li>
              <li>
                <p>
                  The content of comments published on the Fundamentei website and/or any of its products is the sole
                  and exclusive responsibility of the person who published them, and does not express, in any case, the
                  opinion of Fundamentei or its partners.
                </p>
              </li>
              <li>
                <p>
                  Fundamentei may delete, in whole or in part, a certain comment when it believes that its content
                  violates any norm provided by the legislation or the Terms of Service and Privacy Policy, as well as
                  other documents comprising the website and/or any of its products and services.
                </p>
              </li>
              <li>
                <p>
                  If the user continues to publish offensive, disrespectful, fraudulent comments, with advertising
                  intent or in any other improper manner and in clear disregard of the current legislation and the rules
                  of Fundamentei, they may have their commenting permission canceled.
                </p>
              </li>
              <li>
                <p>
                  Through these Terms of Service, the user acknowledges that Fundamentei and its partners have no
                  responsibility of any nature concerning the facts and situations outlined in this document and in the
                  Privacy Policy.
                </p>
              </li>
              <li>
                <p>
                  Fundamentei reserves the right, at any time and without prior notice, to modify these Terms of Service
                  in accordance with its will, always seeking to align with national and international laws regulating
                  the matter. Additionally, any modifications will take effect immediately upon publication on the
                  website and/or other platforms. Therefore, the user is hereby advised to frequently access this
                  document in order to be aware of possible changes.
                </p>
              </li>
              <li>
                <p>
                  In the cases not covered by these Terms of Service, the Privacy Policy provided on the website and/or
                  in any of its products and services will apply subsidiarily, as appropriate.
                </p>
              </li>
            </ul>
          </div>
        </PolicyPage>
      </>
    );
  }
  return (
    <>
      <FundamenteiMetadata title="Termos de Serviço | Fundamentei" />
      <PolicyPage title="Termos de Serviço" lastUpdatedAt={parse("2023-10-25", "yyyy-MM-dd", new Date())}>
        <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
          <p>
            O Fundamentei ("Fundamentei Serviços de Informação LTDA"), inscrito no CNPJ sob nº 35.804.692/0001-05, com
            sede na Av. das Américas, 4200 - bl 1 sl 305, Bairro Barra da Tijuca, Rio de Janeiro/RJ, CEP 22640-907,
            estabelece o presente Termos de Serviço para seus usuários, conforme condições e descrições abaixo:
          </p>
          <ul>
            <li>
              <p>
                O Fundamentei oferece a seus usuários, principalmente, serviços de informações com relação aos ativos
                listados na B3 - Brasil Bolsa Balcão S.A., The Nasdaq Stock Market e The New York Stock Exchange, não se
                restringindo unicamente a esta finalidade. Assim, por meio deste Termo, os usuários concordam com as
                regras e as condições impostas para o uso dos serviços, na forma estabelecida neste Termo e demais
                documentos disponíveis no website e/ou seus produtos.
              </p>
            </li>
            <li>
              <p>
                O propósito do Fundamentei e sua plataforma e/ou produtos, é unicamente informativo, de forma que não
                consiste em recomendações financeiras, legais, fiscais, contábeis ou de qualquer outra roupagem. Assim,
                nenhuma das informações divulgadas por quaisquer um de seus produtos ou canais de comunicação constituem
                oferta ou solicitação de compra, venda, aluguel ou aplicação de ativos financeiros a qualquer título.
              </p>
            </li>
            <li>
              <p>
                Por se tratar de informações coletadas e fornecidas por terceiros (como, mas não limitado a: B3 - Brasil
                Bolsa Balcão S.A., CVM - Comissão de Valores Mobiliários, U.S. Securities and Exchange Commission, The
                Nasdaq Stock Market, The New York Stock Exchange ou demais fontes, serviços e/ou parceiros), o
                Fundamentei não se responsabiliza pelo seu conteúdo ou por quaisquer equívocos, erros, atrasos,
                imprecisões ou omissões nas informações, ficando o usuário ciente que a utilização e a validação da
                integralidade dos serviços/produtos fornecidos é de sua inteira responsabilidade. Entretanto, informamos
                que tomamos cuidados para que as informações e o serviço sejam selecionados da maneira mais correta
                possível. Ainda, o Fundamentei ressalta seu compromisso com a transparência e legalidade, sempre
                observando as legislações pertinentes à propriedade intelectual e direitos autorais.
              </p>
            </li>
            <li>
              <p>
                O Fundamentei e/ou seus parceiros não possuem responsabilidade de qualquer natureza por perdas ou danos,
                de forma direta ou indireta, que decorram de:
              </p>
              <ol className="list-decimal" type="i">
                <li>
                  <p>
                    Erro, imprecisão, parcialidade, ausência, atraso, interrupção ou omissões no fornecimento de dados e
                    de informações relacionadas ao website ou qualquer um de seus produtos sob qualquer plataforma;
                  </p>
                </li>
                <li>
                  <p>
                    Qualquer decisão, omissão ou ação tomada pelo usuário ou por terceiros baseada nestas informações,
                    de forma que não serão responsabilizados pela perda de lucros ou qualquer outro tipo de prejuízo
                    semelhante.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                É assegurado ao Fundamentei, a qualquer tempo, a modificação da forma e do conteúdo, suspensão ou
                cancelamento dos serviços, dos produtos, das utilidades e das aplicações prestadas no site. Ainda, o
                Fundamentei resguarda-se no direito de atualizar e de modificar periodicamente as informações, não
                devendo ser interpretadas como definitivas pelo usuário.
              </p>
            </li>
            <li>
              <p>
                O Fundamentei se compromete com o usuário a manter e divulgar as informações e materiais em sua
                plataforma da forma mais completa, precisa e atualizada possível.
              </p>
            </li>
            <li>
              <p>
                O conteúdo, as informações, os gráficos, as tabelas e os demais dados fornecidos pelo Fundamentei e seus
                parceiros são de uso unicamente pessoal ao usuário, não lhe sendo permitida a cópia, distribuição,
                reprodução, transmissão, exploração, armazenamento ou qualquer outra forma de uso para fins comerciais
                ou qualquer outro que não seja pessoal, muito menos a venda, revenda ou aluguel.{" "}
                <strong>
                  O usuário assume toda e qualquer responsabilidade civil e criminal pelo uso indevido dos serviços e
                  produtos fornecidos pelo Fundamentei e seus parceiros.
                </strong>
              </p>
            </li>
            <li>
              <p>
                Caso seja constatado que o usuário está violando os Termos de Serviço sob qualquer forma, é permitido ao
                Fundamentei o cancelamento da assinatura e/ou bloqueio do acesso a qualquer dos produtos ofertados pelo
                Fundamentei de forma temporária, permanente e inclusive em caráter preventivo.
              </p>
            </li>
            <li>
              <p>
                Fica explicitamente proibido o uso de qualquer instrumento de automação (software, scripts, plataformas
                de terceiros, mas não limitado a estes) para extração, análise ou qualquer tipo de manipulação dos dados
                presentes na plataforma e em qualquer um de seus produtos para quaisquer fins, ficando o usuário ciente
                que caso venha a praticar qualquer conduta aqui exposta será responsabilizado civil e criminalmente
                pelos seus atos.
              </p>
            </li>
            <li>
              <p>
                O cadastro é pessoal, único, intransferível e de uso e responsabilidade exclusiva do usuário, sendo
                proibido o compartilhamento da sua conta/senha com terceiros, independente do vínculo ou grau de
                parentesco e da finalidade (comercial, educativa e entre outras).
              </p>
            </li>
            <li>
              <p>
                Determinadas funcionalidades do nosso site e da nossa plataforma somente serão disponibilizadas mediante
                cadastro e/ou pagamento, de modo que o usuário sempre será alertado de quando o serviço que está
                tentando acessar necessita de cadastro e/ou pagamento, oportunizando-o escolher se deseja pagar pelo
                respectivo serviço/produto.
              </p>
            </li>
            <li>
              <p>
                O Fundamentei não se responsabiliza por qualquer dano gerado em seu computador (softwares e hardwares)
                resultante dos nossos serviços, sendo de inteira responsabilidade do usuário a utilização de medidas de
                segurança para os devidos fins.
              </p>
            </li>
            <li>
              <p>
                O site e os serviços do Fundamentei estão sujeitos a eventuais falhas técnicas, interrupções e/ou
                indisponibilidades de funcionamento temporário, de forma que o Fundamentei se exime de qualquer
                responsabilidade advinda pelos danos gerados em decorrência das situações informadas.
              </p>
            </li>
            <li>
              <p>
                O conteúdo dos comentários publicados no website do Fundamentei e/ou qualquer um de seus produtos são de
                única e exclusiva responsabilidade de quem os publicou, não expressando, em nenhuma hipótese, que é a
                opinião do Fundamentei ou seus parceiros.
              </p>
            </li>
            <li>
              <p>
                O Fundamentei pode excluir, integral ou parcialmente, determinado comentário quando entender que seu
                conteúdo viola qualquer norma prevista pela legislação ou pelos Termos de Serviço e Política de
                Privacidade, bem como demais documentos integrantes do website e/ou qualquer um de seus produtos e
                serviços.
              </p>
            </li>
            <li>
              <p>
                Caso o usuário reitere sua conduta de publicar comentários ofensivos, desrespeitosos, fraudulentos, com
                caráter publicitário ou sob qualquer outra forma indevida e em nítido descompasso com a legislação
                vigente e as normas do Fundamentei, ele poderá ter sua permissão de comentar cancelada.
              </p>
            </li>
            <li>
              <p>
                Por meio deste Termos de Serviço, o usuário reconhece que o Fundamentei e seus parceiros não possuem
                responsabilidade de qualquer natureza com relação aos fatos e situações explicitados neste documento e
                na Política de Privacidade.
              </p>
            </li>
            <li>
              <p>
                O Fundamentei se resguarda no direito de, a qualquer tempo e sem aviso prévio, modificar estes Termos de
                Serviço a fim de acordo com sua vontade, sempre buscando ficar alinhado às normas de Direito nacional e
                internacional que regulam a matéria. Ainda, as modificações que vierem a ocorrer terão vigência imediata
                a partir da divulgação no website e/ou outras plataformas. Portanto, o usuário fica desde já advertido
                que deve acessar frequentemente este documento a fim de estar ciente das possíveis modificações.
              </p>
            </li>
            <li>
              <p>
                Nos casos omissos deste Termos de Serviço, aplicar-se-á subsidiariamente a Política de Privacidade
                prevista no website e/ou em qualquer um de seus produtos e serviços, naquilo que for cabível.
              </p>
            </li>
          </ul>
        </div>
      </PolicyPage>
    </>
  );
}

export default TermsOfService;
